/**
 * 1회성 메시지 **발송 조건 chip** 표시용 헬퍼.
 *
 * 서버가 주는 `{ category: [문구, …] }` 를 chip 목록(문자열 배열)으로 편다.
 *
 * 🔴 종전에는 이 **객체를 그대로** 배열 state 에 넣었다 → `filterCategories.length` 가
 *    `undefined` 라 `undefined > 0` = false ⇒ 조건이 무엇이든 **항상 '전체' 만** 찍혔다.
 *    백엔드가 공들여 만든 라벨(`VolatilityMessageService.filterLabelOf`)의
 *    유일한 소비자가 죽어 있었던 것이다(2026-09-09 발견).
 *
 * 🔑 컴포넌트 파일이 아니라 여기에 둔 이유 = **테스트에서 부를 수 있게**.
 *    `VolatilityMessageDetail.js` 는 `react-markdown`(ESM)을 끌고 와 jest 가 로드하지 못한다.
 *
 * ⛔ 표시 전용이다. 편집기로 되돌려 보내는 값(`filters`)에는 절대 라벨을 쓰지 말 것 —
 *    값 자리에 라벨이 들어가면 저장할 때마다 접두사가 한 겹씩 쌓인다(2026-09-09 500 사고의 원인).
 *
 * 분석: `_ai-runs/2026-09-09_001_onetime_filter_label_roundtrip_500/001_analysis.md`
 */
export const flattenFilterLabels = (byCategory) =>
    Object.values(byCategory ?? {}).flat().filter(Boolean)
